// extracted by mini-css-extract-plugin
export var brand = "_as-9";
export var compact = "_as-6";
export var extraSmall = "_as-7";
export var icon = "_as-0";
export var large = "_as-4";
export var light = "_as-1";
export var medium = "_as-5";
export var outline = "_as-b";
export var primaryDark = "_as-a";
export var primaryLight = "_as-8";
export var primaryModern = "_as-c";
export var success = "_as-2";
export var successSolid = "_as-3";